import {Symbol} from "../reels/Symbol";
import {SYMBOL} from "../enums/Enum";
import {Config} from "../config/Config";

export class SimpleObjectPool<T> {
    public name: string;
    private _items: T[] = [];
    private _itemsInUse: T[] = [];
    private _itemsFree: T[] = [];
    private _growRate: number;
    private _maxSize: number;
    private _factory: () => T;

    constructor(factory: () => T, startSize: number, growRate: number = 1, maxSize?: number) {
        this._factory = factory;
        this._growRate = Math.max(Math.floor(growRate), 1);
        this._maxSize = maxSize ? maxSize : Number.MAX_VALUE;
        this.growPool(startSize);
    }

    public withdraw(): T {
        if (this._itemsFree.length == 0) {
            this.growPool(this._growRate);
        }
        const item = this._itemsFree.pop()!;
        this._itemsInUse.push(item);
        return item;
    }

    public deposit(item: T) {
        const index = this._itemsInUse.indexOf(item);
        if (index >= 0) {
            this._itemsFree.push(this._itemsInUse.splice(index, 1)[0]);
        }
    }

    private growPool(count: number) {
        if (this._items.length >= this._maxSize) {
            debugger;
            throw new Error(this.name + " Pool Exceeding max size: " + this._maxSize);
        }
        for (let i: number = 0; i < count; i++) {
            const newItem = this._factory();
            this._items.push(newItem);
            this._itemsFree.push(newItem);
        }
    }
}